import { MatDialog, MatDialogConfig } from "@angular/material/dialog";
import { StaticPageFormComponent } from "./static-page-form.component";
import { DateTimePeriod } from "../../_typing/date-time-period";
import { DateTimeInstanceService } from "../../services/date-time-instance.service";
import { HeaderDataService } from "../../services/header_data.service";
import { UserService } from "../../services/user.service";
import { take } from "rxjs/operators";

export function openStaticPageEditDialog(
    dialog: MatDialog,
    dateInst: DateTimeInstanceService,
    pageUrlSegment: string,
    dialogTitle: string
): void {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = { pageUrlSegment, title: dialogTitle };
    dialogConfig.panelClass = ['default-form-dialog', 'page-form-dialog'];
    const dialogRef = dialog.open(StaticPageFormComponent, dialogConfig);

    dialogRef.afterClosed().pipe(take(1)).subscribe((result: DateTimePeriod) => {
        if (!result) return;
        dateInst.emitDateTimePeriodChanged(result);
    });
}

export function addEditPageButton(
    headerData: HeaderDataService,
    userService: UserService,
    editPageFn: () => void
): void {
    const editButtonAdded = headerData.buttons.findIndex(b => b.name === 'Edit Page');
    if (userService.canEditStaticPage() && editButtonAdded < 0) {
        headerData.buttons.unshift({
            name: 'Edit Page',
            func: editPageFn,
            params: {},
            class: 'icon-edit hide-xs'
        });
    }
}
